import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { PrimeNGSharedModule } from '@shared/prime/prime-ng.module';

@Component({
  selector: 'app-accept-request-popup',
  imports: [ CommonModule,
    NgOptimizedImage,
    PrimeNGSharedModule],
  templateUrl: './accept-request-popup.component.html',
  styleUrl: './accept-request-popup.component.scss'
})
export class AcceptRequestPopupComponent {
  // Constants

  @Input() visible: boolean = false;
  @Input() showCheckmark: boolean = true;
  @Input() showCloseButton: boolean = true;

  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onClose = new EventEmitter<void>();

  close(): void {
    this.visible = false;
    this.visibleChange.emit(false);
    this.onClose.emit();
  }
}
